
import environment, { currentEnviroment } from '../utils/environmentConfig.json';
export const ipBase =      environment[currentEnviroment].backend.urlBase
export const ipBasepersonas =      environment[currentEnviroment].backendpersonas.urlBase
export const ipFront =      environment[currentEnviroment].frontend.urlBase
export const conection =   environment[currentEnviroment].conection
export const urlBase = `${conection}://${ipBase}/`;

export const urlAuth = `${conection}://${ipBase}/authentication`;
export const urlUsers = `${urlBase}users`;
export const urlBalances = `${urlBase}balances`;
export const urlCustomers = `${urlBase}customers`;
export const urlPayment = `${urlBase}customers`;
export const urlTransactions = `${urlBase}user-transactions`;
export const urlQRGenerator = `${urlBase}qr-generator`;
export const urlDevices = `${urlBase}devices`;
export const urlUserCodes = `${urlBase}user-codes`;
export const urlUserCheckbooks = `${urlBase}user-checkbooks`;
export const urlCheckbooks = `${urlBase}checkbooks`;
export const urlCodes = `${urlBase}codes`;
export const urlTaxes = `${urlBase}taxes`;
export const urlServices = `${urlBase}services`;
export const urlValidates = `${urlBase}validates`;
export const urlUsersDefault = `${urlBase}users-default`;
export const urlTransferCodes = `${urlBase}transfer-codes`;
export const urlVoucher = `${conection}://${ipBase}/docs/comprobantes/`;
export const urlVoucherPersonas = `${conection}://${ipBasepersonas}/docs/comprobantes/`;
export const urlCertificates = `${conection}://${ipBase}/docs/certificates/`;
export const urlValidateCertificates = `${conection}://${ipFront}/certificate-validate`;
export const urlQr = `${conection}://${ipBase}/docs/qr/`;


// icons
export const urlIcons = `${urlBase}icons/`;

